import React, {useState} from 'react';
import CageForm from '../../Components/CageForm'
import CageTable from '../../Components/Tables/CageTable'
import DocumentTable from '../../Components/Tables/DocumentTable'
import SizeAndTypeTable from './SizeAndTypeList'
import './cage-search.css'
const CageSearch = () => { 
  const [cageData, setCageData] = useState([]);
  const [contractData, setContractData] = useState([]);
  
  return (
    <div className="cage-search-page">
      <CageForm setCageData={setCageData} setContractData={setContractData}/>
      <div className="cage-data-and-size">
        <h3>
          <CageTable cageData={cageData?.data || []}/>
        </h3>
        <div>
          <h3 className='cage-size-list-header'>
            Size & Type
          </h3>
          <SizeAndTypeTable cageData={cageData?.data || []}/>
        </div>
      </div>
      <h3>
        Contract History
        <DocumentTable nsnData={contractData?.data || []}/>
      </h3>
    </div>
  )
}

export default CageSearch;